import React, { useState } from 'react';
import { Modal, ModalOverlay, ModalContent, ModalBody, ModalCloseButton } from '@chakra-ui/react';
import UsuarioTable from './UsuariosTable';
import UsuarioDetail from './UsuarioDetalle';

const UsuarioManagement: React.FC = () => {
  const [isModalOpen, setModalOpen] = useState(false);
  const [selectedUsuarioId, setSelectedUsuarioId] = useState<string | null>(null);

  const handleOpenDetail = (id: string | null) => {
    setSelectedUsuarioId(id);
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setSelectedUsuarioId(null);
  };

  return (
    <>
      <UsuarioTable onOpenDetail={handleOpenDetail} />
      <Modal isOpen={isModalOpen} onClose={handleCloseModal} size="lg">
        <ModalOverlay />
        <ModalContent>
          <ModalCloseButton />
          <ModalBody>
            <UsuarioDetail usuarioId={selectedUsuarioId} onClose={handleCloseModal} />
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};

export default UsuarioManagement;
